<app-widget-option [categories]="['LAYERS']" [label]="'FULLY_COLORED'" [limitedTo]="['sticker']">
  <div app-widget-option-content>
    <app-check [color]="color" [value]="widgetLayers.layer(current).stickerFullyColored" (sendValue)="receiveValue($event)"></app-check>
  </div>
</app-widget-option>